import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import validate from '../../../../utils/dataValidation';
import classnames from 'classnames';
import './styles.css';

const isValid = (validation, value, setValid) => {
  const valid = validate(value, validation);
  setValid(valid);
  return valid;
};

const ValidatedInputTrident = ({
  validation,
  name,
  type,
  onChange,
  defaultValue,
  placeholder,
  id,
  displayLabel,
  labelText,
  hidden,
}) => {
  const [valid, setValid] = useState(false);

  useEffect(() => {
    isValid(validation, defaultValue || '', setValid);
  }, [validation, defaultValue]);

  return (
    <fieldset className={classnames('fieldset', `fieldset-${name}`, {'hidden': hidden, 'error': !valid})}>
      {displayLabel && <label className={classnames({'hidden': !labelText})} htmlFor={name}>{labelText}</label>}
      { type === 'textarea' ?
        <textarea
          placeholder={placeholder}
          aria-label={labelText}
          defaultValue={defaultValue}
          id={id}
          name={name}
          onChange={(e) => onChange(name, isValid(validation, e.target.value, setValid), e.target.value)}
        />
        :
        <input
          placeholder={placeholder}
          aria-label={labelText}
          defaultValue={defaultValue}
          type={type}
          id={id}
          name={name}
          onChange={(e) => onChange(name, isValid(validation, e.target.value, setValid), e.target.value)}
        />
      }
    </fieldset>
  );
};

ValidatedInputTrident.propTypes = {
  validation: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  id: PropTypes.string,
  displayLabel: PropTypes.bool,
  labelText: PropTypes.string,
  hidden: PropTypes.bool,
};

export default ValidatedInputTrident;
